import { sendTeaCommEvent } from 'lib/tea-analyze'
import * as React from 'react'

export default function UsedcarLink() {
  return (
    <a
      target="_blank"
      href="/usedcar/sale"
      className="link-wrapper tw-text-color-gray-500 hover:tw-text-white"
      onClick={() => {
        sendTeaCommEvent('clk_event', {
          page_id: 'page_used_car_source_list',
          event_id: 'used_car_high_sell_car',
          button_name: '高价卖车',
        })
      }}
    >
      <i className="DCD_Icon icon_car_24" />
      <span className="tw-ml-4">高价卖车</span>
      <style jsx>
        {`
          .link-wrapper {
            display: block;
            padding: 12px 16px;
            margin-bottom: 4px;
            background: url(${require('./static/usedcar-sale-link-bg.png')}) 0 0 /
              100% 100% no-repeat;
          }
        `}
      </style>
    </a>
  )
}
